<template>
  <div>
    <div>
      <v-toolbar
        background-color="background"
        color="background"
        class="pa-2 d-flex align-center"
        height="42"
      >
        <div class="text-subtitle-1 font-weight-bold">
          메일 전송
        </div>
        <v-spacer />
        <v-btn
          :ripple="false"
          class="me-0 email-sending"
          size="small"
          variant="outlined"
          color="primary"
          @click.stop="emailSending();"
        >
          보내기
        </v-btn>
      </v-toolbar>
      <v-divider />
    </div>

    <div
      class="px-4 pt-4 pb-1"
      style="overflow: hidden;"
    >
      <!-- 이메일 주소 입력 -->
      <div class="w-100">
        <div style="font-size: 15px;">
          받는 사람
        </div>
        <div class="mt-1 d-flex align-start justify-space-between w-100">
          <v-combobox
            v-model="userEmailStore.selectedEmailList_str"

            :items="allAddressList"
            hide-selected
            :menu-props="{ maxHeight: 200, width: 210 }"

            autofocus
            variant="outlined"
            class="no-input-border"
            :class="isValidEmail ? 'mail-input-border' : 'invalid-mail-input-border'"
            style="font-size: 15px; max-width: calc(100% - 55px);"
            hide-details
            :single-line="true"
            density="compact"
            closable-chips
            multiple
            menu-icon=""
            @update:modelValue="setSelectedEmailList"
            @update:search="searchUpdate"
            @focus=" userEmailStore.$changeFocusingState(true);"
            @blur="userEmailStore.$changeFocusingState();"
          >
            <template #chip="{ props, item }">
              <v-chip
                v-bind="props"
                :color="returnIsSaved(item.raw) ? 'primary' : 'green'"
                :class="returnIsSaved(item.raw) ? 'selected-saved-address-chip' : 'selected-unsaved-address-chip'"
              >
                <strong class="text-truncate">{{ item.raw }}</strong>&nbsp;
              </v-chip>
            </template>
          </v-combobox>
          <v-btn
            class="ms-2"
            size="small"
            style="width: 45px; min-width: 45px; height: 40px; min-height: 40px;"
            elevation="0"
            color="primary"
            :ripple="false"
            @click="showEmailContactList();"
          >
            주소록
          </v-btn>
        </div>
        <span
          v-if="!isValidEmail"
          class="invalid-address-error-text"
        >이메일 형식이 아닙니다.</span>
        <!-- 전달내용 입력 -->
        <div class="mt-4 w-100">
          <div style="font-size: 15px;">
            전달 내용
          </div>
          <input
            v-model="emailContent"
            type="text"
            class="mt-1 w-100 email-border-effect"
            hide-details
            placeholder="( 100자 )"
            style="height: 40px; min-height: 40px; padding: 8px 6px 8px 16px; font-size: 15px;"
            @input="onInput"
            @focus=" userEmailStore.$changeFocusingState(true);"
            @blur="userEmailStore.$changeFocusingState();"
          >
        </div>
      </div>

      <!-- 전달할 북마크 리스트 / 선택-->
      <div class="mt-4 w-100">
        <div
          class="d-flex align-center justify-space-between"
          style="font-size: 15px;"
        >
          <div class="d-flex align-center">
            {{ '전달할 북마크' }}<span class="grp-num ma-0">{{ Object.values(userEmailStore.selectedEmailBookmarkSeqs).flat().length }}</span>
          </div>
          <div class="d-flex align-center">
            <label
              class="cursor-pointer"
              style="user-select: none;"
            >
              <input
                v-model="onlySelected"
                class="mb-1"
                style="accent-color: #3182f6;"
                type="checkbox"
              >
              선택한 북마크만 보기
            </label>
          </div>
        </div>
        <div
          :class="{ 'focused': isFocused }"
          class="email-border-effect"
          tabindex="0"
          @mouseup="if(!isFocused) {isFocused = true;}"
          @focusout="isFocused = false;"
        >
          <v-list
            v-if="(userEmailStore.copiedScrapData && userEmailStore.copiedScrapData.length != 0)"
            class="pa-2 ma-0 scroll-container5 emailBookmarkHeight"
            :opened="openBookmarkGroup"
            density="compact"
            nav
            lines="one"
            style="overflow: hidden auto;"
            :activatable="false"
          >
            <v-list-group
              v-for="(group, index) in userEmailStore.copiedScrapData"
              :key="index"
              v-model="openBookmarkGroup"
              :value="group.seq"
            >
              <template #activator="{ props }">
                <!-- 그룹 -->
                <v-list-item
                  class="ms-0 text-left"
                  v-bind="props"
                  :ripple="false"
                  style="min-height: 32px; font-size: 15px; padding: 4px 0px; text-align: left; margin-left: 0px;"
                  @click="setBookmarkGroupOpen(group.seq);"
                >
                  {{ group.name + ' 그룹 ' }}
                  <!-- <span class="grp-num ma-0">{{ !onlySelected ? (group.list ? group.list.length : '0') : (userEmailStore.selectedEmailBookmarkSeqs[group.list[0].groupSeq].length ? `${userEmailStore.selectedEmailBookmarkSeqs[group.list[0].groupSeq].length}개 / ${group.list.length}개` : `0개 / ${group.list ? group.list.length : '0'}개`) }}</span> -->
                  <span class="grp-num ma-0">
                    {{
                      !onlySelected
                        ? (group?.list?.length ?? '0')
                        : `${(userEmailStore.selectedEmailBookmarkSeqs?.[group?.list?.[0]?.groupSeq]?.length ?? '0')}개 / ${(group?.list?.length ?? '0')}개`
                    }}
                  </span>
                </v-list-item>
              </template>

              <v-card
                variant="flat"
                class="pa-0 ma-0 w-100 h-100"
              >
                <v-list
                  v-if="!onlySelected || (userEmailStore.selectedEmailBookmarkSeqs[group.seq]?.length &gt; 0)"
                  class="pa-0"
                  nav
                  base-color="transparent"
                >
                  <v-list-item
                    v-for="(scrap, i) in getFilteredList(group)"
                    :id="'email-bookmark-list-' + index + '-' + i"
                    :key="i"
                    :ripple="false"
                    class="pa-0 ma-0"
                    style="min-height: 32px;"
                    @click="userJS.moveElementPosition('scroll-container5', 'email-bookmark-list-' + index + '-' + i);"
                  >
                    <div class="d-flex">
                      <!-- 점선 -->
                      <div :class="i !== getFilteredList(group)?.length - 1 ? 'custom-border1' : 'custom-border2'" />

                      <!-- 아이콘과 북마크 텍스트 -->
                      <v-icon
                        size="small"
                        color="#DBDBDB"
                        :class="{'select-email-bookmark': userEmailStore.selectedEmailBookmarkSeqs[scrap.groupSeq]?.includes(scrap.scrapSeq)}"
                        class="mt-1 ms-2"
                        @click="selectEmailBookmark(scrap);"
                      >
                        {{ userEmailStore.selectedEmailBookmarkSeqs[scrap.groupSeq]?.includes(scrap.scrapSeq) ? 'mdi-bookmark-check' : 'mdi-bookmark' }}
                      </v-icon>
                      <div class="d-flex align-center w-100">
                        <!-- 텍스트 문장 -->
                        <div
                          class="email-bookmark-text"
                          style="max-width: calc(100% - 75px); user-select: none;"
                          :class="userEmailStore.selectedEmailBookmarkSeqs[scrap.groupSeq]?.includes(scrap.scrapSeq) ? 'select-email-bookmark' : ''"
                          @click="selectEmailBookmark(scrap);"
                        >
                          {{ scrap.title }}
                        </div>
                        <!-- 북마크 열기 버튼 -->
                        <span
                          class="more-link ms-1"
                          @click.stop="showEmailBookmarkImage(scrap);"
                        >
                          더보기
                        </span>
                      </div>
                    </div>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-list-group>
          </v-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, nextTick, watch, onBeforeMount } from "vue";
  // import { useDisplay } from 'vuetify'
  // const { mobile } = useDisplay();

  import { commonJS, userJS } from "@/assets/js";
  import { useUserStore, useUserAlertStore, useUserEmailStore } from '@/store';
  const userEmailStore = useUserEmailStore();
  const userAlertStore = useUserAlertStore();

  const props = defineProps({
    mediaSeq:String, tab: String, dragging: Boolean,
  });
  // const $emit = defineEmits(['', ]);

  const emailContent = ref('');
  const isFocused = ref(false);

  /**
   * 좌측 헤더 탭 변경, 또는 새로고침 시 전부 리셋되도록
   */
  function resetMailSide(){
    userEmailStore.selectedEmailList_str = [];      // 주소 입력창
    emailContent.value = '';                        // 전달 내용
    isFocused.value = '';                           // 활성화된 작업창 여부
    onlySelected.value = false;                     // '선택한 북마크만 보기' 선택 여부

    // 선택된 북마크 seq 객체 초기화
    userEmailStore.selectedEmailBookmarkSeqs = {};
    if(!userEmailStore.copiedScrapData) return;
    userEmailStore.copiedScrapData.forEach(g => {
      const groupSeq = g.list?.[0]?.groupSeq;
      if (groupSeq !== undefined) {
        userEmailStore.selectedEmailBookmarkSeqs[groupSeq] = [];
      }
    });
  }
  watch(()=>props.tab, (newVal, oldVal)=>{
    searchText.value = ''; // allAddressList.value - 해당 computed 값에 의해 받는 사람 입력창 - filter 창 resize error를 피하기 위함
    if(oldVal != 'option-4' && newVal == 'option-4'){
      resetMailSide();
    }
  })
  onBeforeMount(()=>{
    resetMailSide();
  })

  /**
   * 받는 사람 입력창 기능
   */
  const searchText = ref('');     // 검색어가 있을 때에만 allAddressList가 입력창 하단에 보이도록.
  const isValidEmail = ref(true); // validation css을 구현하기 위함.
  // 검색어 입력할 때마다 호출됨.
  function searchUpdate(val) {
    searchText.value = val;
    isValidEmail.value = !val || userEmailStore.$isValidEmail(val);
  }
  // 검색 대상이 되는 모든 이메일 목록 반환
  const allAddressList = computed(()=>{
    if(!searchText.value) return [];
    if(props.dragging) return []; // 메일 전송 탭 너비 조절 시에는 띄우지 않기
    let dataList = userEmailStore.emailData?.map(email=> `${email.alias} <"${email.address}">`);
    return dataList || [];
  })
  // 추가한 주소가 기존 주소록에 저장된 것인지 여부 반환
  function returnIsSaved(chip_address){
    let index = userEmailStore.emailData.findIndex(email => chip_address.includes(email.address) );
    if(index != -1){
      return true;
    }
    return false
  }

  // 새로운 이메일을 추가할 때 호출됨.
  function setSelectedEmailList(arr=[]){
    if(userEmailStore.prevAddressLength > arr.length) {
      userEmailStore.prevAddressLength = arr.length;
      return; // 삭제되는 작업에서는 실행 안 하도록.
    }
    let lastText = arr[arr.length-1];
    if(!userEmailStore.$isValidEmail(lastText)){
      userEmailStore.selectedEmailList_str.splice(arr.length-1, 1);
      return;
    }
    userEmailStore.prevAddressLength = arr.length;
  }

  /**
  * 이메일로 보낼 북마크 선택 기능
  */
  function selectEmailBookmark(scrap) {
    const groupSeq = scrap.groupSeq;
    const scrapSeq = scrap.scrapSeq;

    // 해당 groupSeq가 selectedEmailBookmarkSeqs에 없다면 초기화
    if (!userEmailStore.selectedEmailBookmarkSeqs[groupSeq]) {
      userEmailStore.selectedEmailBookmarkSeqs[groupSeq] = [];
    }

    const selectedList = userEmailStore.selectedEmailBookmarkSeqs[groupSeq];
    const index = selectedList.indexOf(scrapSeq);

    if (index !== -1) {
      selectedList.splice(index, 1);
      scrap.selected = false;
    } else {
      selectedList.push(scrapSeq);
      scrap.selected = true;
    }
  }

  /**
  * userEmailStore.localScrapData 변경될 때마다 선택한 북마크 목록도 갱신하기.
  */
  watch(()=>userEmailStore.localScrapData, (newVal)=>{
    newVal.forEach(newGroup=>{
      const prevList = userEmailStore.selectedEmailBookmarkSeqs[newGroup.seq];
      if (!prevList) return;

      const validSeqs = newGroup.list?.map(scrap => scrap.scrapSeq) || [];
      const filteredList = prevList.filter(seq => validSeqs.includes(seq));

      // 선택된 북마크 리스트 갱신
      userEmailStore.selectedEmailBookmarkSeqs[newGroup.seq] = filteredList;
    })
  })

  /**
   * 선택한 북마크만 보기 기능
   */
  const onlySelected = ref(false);
  function getFilteredList(group) {
    // if (!group || !group.list) return [];

    // if(!onlySelected.value) {
    //   return group.list;
    // }

    // // '선택한 북마크만 보기' 체크했을 때.
    // console.log(group);

    // // selectEmailBookmark(scrap)에 의해 추가된 selected 속성 여부를 확인해서 true인 scrap 정보만 보여주기.
    // return group.list.filter(scrap => scrap.selected);

    if (!group || !group.list) return [];

    return onlySelected.value// -> '선택한 북마크만 보기' 체크했을 때.
      ? group.list.filter(scrap => scrap.selected)// -> selectEmailBookmark(scrap)에 의해 추가된 selected 속성 여부를 확인해서 true인 scrap 정보만 보여주기.
      : group.list;
  }

  /**
   * 전달 내용 : 100자 내로만 작성 가능 기능
   */
  function onInput(e) {
    // 한글 100자까지만
    const val = e.target.value;
    if (val.length > 100) {
      emailContent.value = val.slice(0, 100);
    }
  }

  /**
   * 이메일-북마크 목록 펼치고, 접는 기능
   */
  // const openBookmarkGroup = ref([]);
  let openBookmarkGroup = computed(()=>{
    let arr = [];
    userEmailStore.copiedScrapData.forEach(g=>{
      arr.push(g.seq);
    })
    return arr;
  });
  function setBookmarkGroupOpen(groupSeq) {
    const pageIndex = openBookmarkGroup.value.indexOf(groupSeq);
    if (pageIndex !== -1) {
      openBookmarkGroup.value.splice(pageIndex, 1);
    } else {
      // 북마크 그룹 열린 상태 여부 결정하는 배열.
      openBookmarkGroup.value.push(groupSeq);
    }
  };

  /**
   * 해당 이메일-주소록을 모달로 띄우는 기능
   * 모달은 HeaderPage.vue에서 EmailModal.vue 화면을 v-overlay 태그를 활용하고 띄우고 있음.
   */
  function showEmailContactList() {

    userEmailStore.isTotal = false;
    let count = 0;
    userEmailStore.emailData.forEach(email => email.isSelected = false);
    userEmailStore.selectedEmailList_arr = [];
    userEmailStore.selectedEmailList_str.forEach(str => {
      let index = userEmailStore.emailData.findIndex(email => str.includes(email.address));
      if(index != -1){
        count++;
        userEmailStore.emailData[index].isSelected = true;
        userEmailStore.selectedEmailList_arr.push(userEmailStore.emailData[index]);
      } else {
        userEmailStore.selectedEmailList_arr.push({
          alias: null,
          addressSeq : null,
          address : str.replaceAll('<', '').replaceAll('>', '').replaceAll('"', '').trim(),
          isSaved : false,
          isSelected : true,
        });
      }
    });

    if(count == userEmailStore.emailData.length) { // 입력창에서 주소록 전체 이메일을 입력한 후 주소록 버튼 클릭 시 전체 선택 상태 만들기 위함.
      userEmailStore.isTotal = true;
      userEmailStore.isAlreadyALLSelected = true;  // 주소록 작업창 EmailModal.vue의 userEmailStore.isTotal를 감시하는 watch에 의한 기능 실행을 막기 위함.
    } else {
      userEmailStore.isTotal = false;
      userEmailStore.isAlreadyALLSelected = false;
    }

    // 기존 데이터 초기화
    userEmailStore.copiedEmailData = [];
    userEmailStore.copiedSelectedEmailList_arr = [];

    userEmailStore.copiedEmailData = JSON.parse(JSON.stringify(userEmailStore.emailData));
    userEmailStore.copiedSelectedEmailList_arr = JSON.parse(JSON.stringify(userEmailStore.selectedEmailList_arr));

    userEmailStore.isShowBookmark = false;
    userEmailStore.isEmailOverlayOn = true;

    // css - 기존 이메일 선택 상태 해제
    const groupListItems = document.querySelectorAll('.email-list-item');
    groupListItems.forEach(item => {
      item.classList.remove('v-list-item--active'); // 기존 선택 해제
    });

    nextTick(()=>{// 작업창(모달창 띄울 때마다 스크롤이 맨 위로 향하도록)
      const gList = document.getElementById('emailList');
      if (gList) {
        gList.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
      const kList = document.getElementById('selectedEmailList');
      if (kList) {
        kList.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    })

    // 이 함수 끝난 직후
    // 주소록 작업창 EmailModal.vue의 userEmailStore.isTotal를 감시하는 watch하는 코드 실행됨.
  }

  /**
   * 해당 이메일-북마크 내용을 모달로 띄우는 기능
   * 모달은 HeaderPage.vue에서 EmailModal.vue 화면을 v-overlay 태그를 활용하고 띄우고 있음.
   */
  function showEmailBookmarkImage(scrap) {
    userEmailStore.scrap = scrap;
    userEmailStore.isShowBookmark = true;

    let imageUrl = userEmailStore.$returnBookmarkImage(scrap, props.mediaSeq);
    userEmailStore.emailBookmarkImageUrl = imageUrl;

    userEmailStore.isEmailOverlayOn = true;
  }

  /**
   * '보내기' 버튼 기능
   */
  async function emailSending() {
    if (!userEmailStore.selectedEmailList_str.length) {
      alert('받는 사람의 이메일 주소를 입력해주세요.');
      return;
    }

    let bookmarks = Object.values(userEmailStore.selectedEmailBookmarkSeqs).flat();
    if (!bookmarks.length) {
      alert('북마크한 기사를 공유하기 위한 메일 전송 기능입니다.\n반드시 1개 이상의 북마크를 선택해 주십시오.');
      return;
    }

    userEmailStore.selectedEmailList_arr = [];
    userEmailStore.selectedEmailList_str.forEach(str => {
      let index = userEmailStore.emailData.findIndex(email => str.includes(email.address));
      if(index != -1){
        userEmailStore.emailData[index].isSelected = true;
        userEmailStore.selectedEmailList_arr.push(userEmailStore.emailData[index]);
      } else {
        userEmailStore.selectedEmailList_arr.push({
          alias: null,
          addressSeq : null,
          address : str.replaceAll('<', '').replaceAll('>', '').replaceAll('"', '').trim(),
          isSaved : false,
          isSelected : true,
        });
      }
    });

    // 받는 사람 이메일 string 배열
    let emails = userEmailStore.selectedEmailList_arr.map(selection => ({
      name: selection.alias || '',
      email: selection.address,
    }));


    const params = {
      emails: emails,
      contents: emailContent.value,  // 전달 내용
      bookmarks: bookmarks,   // (같은 기사에 대한 북마크가 서로 다른 그룹에 있더라도) scrapSeq가 중복되지 않는, 전달할 북마크 seq들 담은 배열
    };

    try {
      let res = await commonJS.httpAPI("/userSendMail", "POST", params, {
        headers: { "Content-Type": "application/json" }
      });
      if(res.success) {
        // 기존 켜져있던 모든 alert창 끄기
        userAlertStore.$resetAllAlert();
        userAlertStore.$changeAlertInfo({
          status: 'email-sent',
        });
        userAlertStore.$changeAlertFT('email', 'send');

      } else {
        console.warn('이메일 전송 과정 실패:', res?.msg || '응답 없음');
      }
    } catch (error) {
      console.error('이메일 전송 중 오류 발생:', error);
    }

  }

</script>

<style scoped>
/* 저장된 검색 키워드 열고 닫기 시.. v-expand-transition태그와 같이 사용됨. */
.expandable-list {
  transition: max-height 0.5s ease-in-out, opacity 0.3s ease-in-out;
  max-height: 200px;
  opacity: 1;
  overflow: hidden;
}

/* 이메일 보내기 버튼 호버 기능 */
.email-sending:hover {
  transition: 0.3s ease-in-out;
  background-color: #f5f5f5;
}

/* 받는사람 입력창 css */
::v-deep(.mail-input-border .v-field--variant-outlined .v-field__outline .v-field__outline__start) {
  border: 1px solid #DDDDDD !important;
  border-right: none !important;
  opacity: 1;
  transition: border-color 0.5s ease;
}
::v-deep(.mail-input-border .v-field--variant-outlined:hover .v-field__outline .v-field__outline__start),
::v-deep(.mail-input-border .v-field--variant-outlined.v-field--focused .v-field__outline .v-field__outline__start) {
  border-color: rgba(0, 0, 0, 0.87) !important;
}
::v-deep(.mail-input-border .v-field--variant-outlined.v-theme--darkTheme:hover .v-field__outline .v-field__outline__start),
::v-deep(.mail-input-border .v-field--variant-outlined.v-theme--darkTheme.v-field--focused .v-field__outline .v-field__outline__start) {
  border-color: #DDDDDD !important;
}
::v-deep(.invalid-mail-input-border .v-field--variant-outlined.v-field--focused .v-field__outline .v-field__outline__start) {
  border-bottom-width : 1px !important;
  border-bottom-color : red !important;
  border-left-width : 1px !important;
  border-left-color : red !important;
  border-top-width : 1px !important;
  border-top-color : red !important;
}

::v-deep(.mail-input-border .v-field--variant-outlined .v-field__outline .v-field__outline__end) {
  border: 1px solid #DDDDDD !important;
  border-left: none !important;
  opacity: 1;
  transition: border-color 0.5s ease;
}
::v-deep(.mail-input-border .v-field--variant-outlined:hover .v-field__outline .v-field__outline__end),
::v-deep(.mail-input-border .v-field--variant-outlined.v-field--focused .v-field__outline .v-field__outline__end) {
  border-color: rgba(0, 0, 0, 0.87) !important;
}
::v-deep(.mail-input-border .v-field--variant-outlined.v-theme--darkTheme:hover .v-field__outline .v-field__outline__end),
::v-deep(.mail-input-border .v-field--variant-outlined.v-theme--darkTheme.v-field--focused .v-field__outline .v-field__outline__end) {
  border-color: #DDDDDD !important;
}
::v-deep(.invalid-mail-input-border .v-field--variant-outlined.v-field--focused .v-field__outline .v-field__outline__end) {
  border-bottom-width : 1px !important;
  border-bottom-color : red !important;
  border-right-width : 1px !important;
  border-right-color : red !important;
  border-top-width : 1px !important;
  border-top-color : red !important;
}

.invalid-address-error-text {
  display: block;
  color: red;
  font-size: 13px;
  margin-top: 4px;
  display: block;
}

::v-deep(.no-input-border input) {
  border: none !important;
  padding: 0px;
}

.v-theme--darkTheme .email-border-effect:hover,
.v-theme--darkTheme .email-border-effect:focus{
  border-color: white !important;
}

::v-deep(.selected-saved-address-chip .mdi:before){
  color: #3182f6;
}
::v-deep(.selected-unsaved-address-chip .mdi:before){
  color: green;
}

/* 받는사람, 전달 내용 입력창 css */
.email-border-effect {
  border: 1px solid #ddd !important;
  border-radius: 4px;
  transition: border-color 0.5s ease;
}
.email-border-effect:hover, .email-border-effect:focus {
  border-color : rgb(0, 0, 0, 0.87) !important;
}
.email-border-effect.focused {
  border-color: rgb(0, 0, 0, 0.87) !important;
}
.v-theme--darkTheme .email-border-effect:hover,
.v-theme--darkTheme .email-border-effect:focus{
  border-color: white !important;
}

/* 전달할 북마크 리스트 점선 */
.custom-border1 {
  position: relative;
  width: 1px; /* div의 너비 */
  border-left: 1px dashed black;
}
.custom-border2 {
  position: relative;
  width: 1px; /* div의 너비 */
  height: 15px;
  border-left: 1px dashed black;
}
.custom-border1::before {
  content: "";
  position: absolute;
  left: 3px;
  top: 25%;
  transform: rotate(90deg); /* 정확한 중앙 정렬 */
  width: 1px;
  height: 8px;
  border-left: 1px dashed black;
}
.custom-border2::before {
  content: "";
  position: absolute;
  left: 3px;
  bottom: -4px;
  transform: rotate(90deg); /* 정확한 중앙 정렬 */
  width: 1px;
  height: 8px;
  border-left: 1px dashed black;
}
.v-theme--darkTheme .custom-border1,
.v-theme--darkTheme .custom-border2,
.v-theme--darkTheme .custom-border1::before,
.v-theme--darkTheme .custom-border2::before {
  border-left: 1px dashed white;
}

/* 전달할 북마크 리스트 텍스트 */
.email-bookmark-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  font-size: 15px;
  cursor: pointer;
  margin: 0 4px;
  color: black;
}
.more-link {
  width: 45px;
  min-width: 45px;
  height: 24px;
  min-height: 24px;

  white-space: nowrap;
  font-size: 12px;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.4);

  flex-shrink: 0;
}
.v-theme--darkTheme .email-bookmark-text,
.v-theme--darkTheme .more-link {
  color: white;
}

/* 전달할 북마크 표시 */
.select-email-bookmark {
  user-select: none;
  font-weight: bold;
  color: #3182f6 !important;
}
::v-deep(.select-email-bookmark.mdi:before) {
  color: #3182f6 !important;
}


</style>
